import Component from 'can/component/component';
import template from './featured-group-header.stache';
import { DRAWER_TYPES } from 'components/leaderboard/drawer/drawer';
import { shortenName } from 'components/video-landing/live-video-right-rail/live-video-right-rail-channels/channel/channel';
import dtm from 'scripts/services/dtm';

Component.extend({
    tag: 'featured-group-header',
    template: template,
    viewModel: {
        define: {
            fetching: {
                type: 'boolean',
                value: false,
            },
            data: {
                type: 'array',
                value: null,
            },
            currentPlayer: {
                type: 'string',
            },
            drawerData: {
                type: 'object',
                value: null,
            },
            swiperData: {
                type: 'object',
                value: null,
            },
            channelName: {
                type: 'string',
                value: '',
            },
            DRAWER_TYPES: {
                type: 'object',
                value: DRAWER_TYPES,
            },
            showDrawer: {
                type: 'boolean',
                value: true,
            },
        },
        setCurrent(playerId) {
            if (!playerId) {
                return;
            }

            this.attr('currentPlayer', playerId);

            const playerData = this.attr('data')
                .filter((it) => it.identifier === playerId)
                .attr(0);

            this.attr('drawerData', { player: playerData });
            this.attr('showDrawer', false);
            setTimeout(() => {
                this.attr('showDrawer', true);
            }, 200);
            dtm.trackWatchLivePlayerTabClick(playerData.title);
        },
    },
    events: {
        inserted() {
            this.viewModel.bind('data', (_, value) => {
                const id = value.attr('0.identifier');

                if (!id) {
                    return;
                }

                this.viewModel.attr('fetching', true);

                this.mapSwiperData();
                this.viewModel.setCurrent(id);

                this.viewModel.attr('fetching', false);
            });

            this.mapSwiperData();
            this.viewModel.setCurrent(this.viewModel.attr('data.0.identifier'));
        },

        mapSwiperData() {
            const data = this.viewModel.attr('data').serialize();
            const swiperData = data.map(({ headshot, identifier, title }) => ({
                image: headshot,
                identifier,
                title: shortenName(title),
            }));

            this.viewModel.attr('swiperData', swiperData);
        },
    },
});
